/*!
 * devextreme-react
 * Version: 24.2.3
 * Build date: Fri Dec 06 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOptionScanning = void 0;
const react_1 = require("react");
const element_1 = require("./configuration/react/element");
const utils_1 = require("./configuration/utils");
const config_node_1 = require("./configuration/config-node");
const templates_1 = require("./configuration/react/templates");
const contexts_1 = require("./contexts");
function useOptionScanning(optionElement, children, templateContainer, parentUpdateToken) {
    const parentContext = (0, react_1.useContext)(contexts_1.NestedOptionContext);
    const { parentFullName, } = parentContext;
    const updateToken = Symbol('update token');
    const configBuilder = (0, config_node_1.createConfigBuilder)(optionElement, parentFullName);
    react_1.Children.forEach(children, (child) => {
        const elementType = (0, element_1.getElementType)(child);
        if (elementType === element_1.ElementType.Template) {
            const templateElement = child;
            const template = (0, templates_1.getNamedTemplate)(templateElement.props);
            if (template) {
                configBuilder.addTemplate(template);
            }
        }
    });
    const childComponentCounter = (0, react_1.useRef)(0);
    const context = {
        parentExpectedChildren: optionElement.descriptor.expectedChildren,
        parentFullName: (0, utils_1.mergeNameParts)(parentFullName, optionElement.descriptor.name),
        treeUpdateToken: updateToken,
        getOptionComponentKey: () => {
            childComponentCounter.current += 1;
            return childComponentCounter.current;
        },
        onChildOptionsReady: (childConfigNode, childDescriptor, childUpdateToken, childComponentKey) => {
            if (childUpdateToken !== updateToken) {
                return;
            }
            const { isCollection, name } = childDescriptor;
            if (isCollection) {
                configBuilder.addCollectionNode(name, childConfigNode, childComponentKey);
                return;
            }
            configBuilder.addChildNode(name, childConfigNode);
        },
    };
    (0, react_1.useLayoutEffect)(() => {
        const hasTemplateRendered = templateContainer.childNodes.length > 0;
        configBuilder.updateAnonymousTemplates(hasTemplateRendered);
    }, [parentUpdateToken]);
    return [configBuilder.node, context];
}
exports.useOptionScanning = useOptionScanning;
